"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryModule = void 0;
const router_1 = require("client/components/router");
const inventory_confirmation_1 = require("./modules/inventory-confirmation");
const inventory_create_1 = require("./modules/inventory-create");
const inventory_detail_1 = require("./modules/inventory-detail");
const inventory_label_information_1 = require("./modules/inventory-label-information");
// import { GroupManagementModal } from './modules/inventory-detail/components/edit-inventory/group-management-modal';
const inventory_list_1 = require("./modules/inventory-list");
const inventory_manual_create_1 = require("./modules/inventory-manual-create/");
const inventory_search_1 = require("./modules/inventory-search");
const inventory_warning_labels_1 = require("./modules/inventory-warning-labels");
class InventoryModule extends router_1.Router {
    constructor(props) {
        super(props);
        this.addRoute("list", /^\/formulary\/?$/, inventory_list_1.InventoryList);
        // this.addRoute('dragmodal', /^\/formulary\/dragmodal\/?$/, GroupManagementModal);
        this.addRoute("new", /^\/formulary\/new\/?$/, inventory_create_1.InventoryCreate);
        this.addRoute("confirm", /^\/formulary\/new\/(\d+)\/?$/, inventory_confirmation_1.InventoryConfirmation);
        // this.addRoute('detail', /^\/formulary\/(\d+)/, InventoryDetail);
        // this.addRoute("detail", /^\/formulary\/(\d+)?\/?(\d+)?/, InventoryDetail);
        this.addRoute("detail", /^\/formulary\/(\d+)\/(\d+)?/, inventory_detail_1.InventoryDetail);
        this.addRoute("manual/input", /^\/formulary\/new\/manual\/?$/, inventory_manual_create_1.InventoryManualCreate);
        // this.addRoute(
        //   "inventory/warning-labels",
        //   /^\/formulary\/warnings\/(\d+)\/?$/,
        //   InventoryWarningLabels
        // );
        // this.addRoute(
        //   "inventory/label-information",
        //   /^\/formulary\/information\/(\d+)\/?$/,
        //   InventoryLabelInformation
        // );
        this.addRoute("inventory/warning-labels", /^\/formulary\/warnings\/(\d+)\/(\d+)\/?$/, inventory_warning_labels_1.InventoryWarningLabels);
        this.addRoute("inventory/label-information", /^\/formulary\/information\/(\d+)\/(\d+)\/?$/, inventory_label_information_1.InventoryLabelInformation);
        this.addRoute("search", /^\/formulary\/search/, inventory_search_1.InventorySearch);
        this.addRoute("detail", /^\/formulary\/(\d+)/, inventory_detail_1.InventoryDetail);
        this.addRoute("manual/input", /^\/formulary\/new\/manual\/?$/, inventory_manual_create_1.InventoryManualCreate);
        this.addRoute("inventory/warning-labels", /^\/formulary\/warnings\/(\d+)\/?$/, inventory_warning_labels_1.InventoryWarningLabels);
        this.addRoute("inventory/label-information", /^\/formulary\/information\/(\d+)\/?$/, inventory_label_information_1.InventoryLabelInformation);
    }
}
exports.InventoryModule = InventoryModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/inventory.tsx
// module id = 3454
// module chunks = 0